import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';
import Topbar from '../common/Topbar';
import Footer from '../common/Footer';
import TitleText from '../common/TitleText';
import GoogleMapReact from 'google-map-react';
import RoomSharpIcon from '@material-ui/icons/RoomSharp';

const styles = (theme) => ({
  bg: {
    width: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
    backgroundColor: '#fafafa',
  },
  content_bg: {
    backgroundColor: '#ffffff',
    margin: '4vh auto',
    width: '100%',
    borderRadius: '20px',
  },
  descTxt: {
    paddingLeft: '20px',
  },
  cate: {
    color: theme.palette.secondary.point,
    fontWeight: 'bold',
  },
  descOuter: {
    marginLeft: '50px',
    height: '300px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
  },
});

const AnyReactComponent = ({ text }) => (
  <div>
    <RoomSharpIcon style={{ color: '#CA5A48' }} />
  </div>
);

class Comeon extends Component {
  static defaultProps = {
    center: {
      lat: 37.5418246,
      lng: 127.0614403,
    },
    zoom: 15,
  };

  constructor(props) {
    super(props);
    this.state = {
      now: new Date(),
      value: 0,
      matches: window.matchMedia('(max-width:600px)').matches,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    // axios.get(`${API_URL}/notice/list?eventId=${EVENT_ID}&limit=-1`, { headers: { Pragma: 'no-cache' } }).then((response) => {
    //   // console.log(response.data.Items);
    //   response.data.Items.sort((a, b) => {
    //     return Number(a.sortOrder) > Number(b.sortOrder) ? 1 : -1;
    //   });
    //   this.setState({ noticeData: response.data.Items });
    // });
  }
  handleChange(event, newValue) {
    this.setState({ value: newValue });
    // console.log(this.state.value);
  }
  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <Topbar />
        <Grid container justify="center" className={classes.bg}>
          <Grid item xs={10} className={classes.content_bg}>
            <TitleText title="찾아오시는 길" />
            <div style={{ padding: '0 10vw' }}>
              <Grid container style={{ paddingBottom: '30px' }}>
                <Grid item xs={12} sm={6}>
                  <div style={{ height: '50vh', width: '100%' }}>
                    <GoogleMapReact
                      bootstrapURLKeys={{ key: 'AIzaSyAZjrcfrfMHdOCn8za5Vy9ht_fdrH7Vd5Q' }}
                      defaultCenter={this.props.center}
                      defaultZoom={this.props.zoom}
                    >
                      <AnyReactComponent lat={37.5418246} lng={127.0614403} text="My Marker" />
                    </GoogleMapReact>
                  </div>
                </Grid>
                <Grid container direction="column" justify="center" item xs={12} sm={6}>
                  <div className={classes.descOuter}>
                    <Typography variant="h6" className={classes.cate} style={{ color: '#555', marginLeft: '10px' }}>
                      (주)두원시스템
                    </Typography>
                    <Typography
                      variant="h6"
                      className={classes.cate}
                      style={{ marginTop: '10px', marginLeft: '10px', display: 'flex', alignItems: 'center' }}
                    >
                      <span style={{ paddingRight: '10px' }}>
                        <img src="/images/icon/home_ic@2x.png" alt={'address'} style={{ width: '1em', height: '1em', display: 'flex' }} />
                      </span>
                      주소
                    </Typography>
                    <Typography variant="body1" className={classes.descTxt}>
                      서울시 성동구 연무장17길 14, 503호
                      <br />
                      (성수동2가 대군인더스타운)
                    </Typography>
                    <Typography
                      variant="h6"
                      className={classes.cate}
                      style={{ marginTop: '10px', marginLeft: '10px', display: 'flex', alignItems: 'center' }}
                    >
                      <span style={{ paddingRight: '10px' }}>
                        <img src="/images/icon/phone_ic@2x.png" alt={'address'} style={{ width: '1em', height: '1em', display: 'flex' }} />
                      </span>
                      연락처
                    </Typography>
                    <Typography variant="body1" className={classes.descTxt}>
                      Tel. 02-529-5666
                      <br />
                      Fax. 02-468-0083
                    </Typography>
                    <Typography
                      variant="h6"
                      className={classes.cate}
                      style={{ marginTop: '10px', marginLeft: '10px', display: 'flex', alignItems: 'center' }}
                    >
                      <span style={{ paddingRight: '10px' }}>
                        <img src="/images/icon/letter_ic@2x.png" alt={'address'} style={{ width: '1em', height: '1em', display: 'flex' }} />
                      </span>
                      이메일
                    </Typography>
                    <Typography variant="body1" className={classes.descTxt}>
                      ohydoo@hanmail.net
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Footer />
        </Grid>
      </React.Fragment>
    );
  }
}
export default withRouter(withStyles(styles, { withTheme: true })(Comeon));
